import { styled } from "../../styled-components";
import { mobileSystemFontFamily } from "../../lib/theme/theme";

export const Wrapper = styled.div<{ showSearch: boolean }>`
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: stretch;
    min-height: 100%;
    height: 100%;

    ::-webkit-scrollbar {
        display: none;
    }

    overflow-y: auto;

    padding-top: ${p =>
        p.theme.navBar.style !== "Android" && p.showSearch ? p.theme.navBar.heightWithSearch : p.theme.navBar.height}px;

    font-family: ${mobileSystemFontFamily};
`;

export const ItemBox = styled.div`
    margin-left: 16px;

    flex-shrink: 0;

    height: 48px;
    border-bottom: 1px solid ${p => p.theme.separatorColor};

    color: ${p => p.theme.fgColorDark};

    :active {
        background-color: ${p => p.theme.offBaseColor};
    }

    display: flex;
    align-items: center;
    justify-content: flex-start;
`;
